import script from "./TressFormSuccess.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressFormSuccess.vue?vue&type=script&lang=ts&setup=true"

import "./TressFormSuccess.vue?vue&type=style&index=0&id=4931e566&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4931e566"]])

export default __exports__